import {useApi} from "./useApi";
import {useFetching} from "./system/useFetching";
import {useCallback} from "react";
import {dispatcher} from "../store";
import {useNotify} from "./system/useNotify";


export function useLogin() {
  const {api} = useApi(),
    {addNotify} = useNotify(),
    {withFetching} = useFetching();

  const login = useCallback(async (username: string, password: string) => {
    const credentials = {username, password}
    const res = await withFetching(api.postAuthLogin({credentials}));
    if (res.status === 200) {
      dispatcher.user.setProfile(res.body)
    } else if (res.status === 400) {
      addNotify('error', 'Error', res.body.messages?.join("\n"))
    } else {
      addNotify('error', 'Unknown error', )
    }

  }, [addNotify, api, withFetching]);

  const logout = useCallback(() => {
    dispatcher.user.logout()
  }, [])

  return {login, logout}
}
